'use strict';

export default class PageNousContacter {
  constructor(options) {
    console.log('PageNousContacter component');

    const defaults = {
        requiredClass: '.required',
        toggleActionCopy: '#edit-field-moi-meme',
        masks: {
          departmentReserche: {
            selector: '#edit-field-departements-recherche',
            mask: '00-00-00'
          },
          budgetReserche: {
            selector: '#edit-field-budget-recherche',
            mask: '€ 00000'
          }
        }
    };

    this.options = Object.assign({}, defaults, options);

    //initial methods
    this._copyToggleAction(this.options.toggleActionCopy);
    this._applyMasks();

  }

  _applyMasks() {
    $(this.options.masks.departmentReserche.selector).mask(this.options.masks.departmentReserche.mask);
    $(this.options.masks.budgetReserche.selector).mask(this.options.masks.budgetReserche.mask);
  }

  _copyValue(from, to) {
    $(to).val($(from).val());
  }

  _copyValues(arrFrom, arrTo) {
    for (var i = arrFrom.length - 1; i >= 0; i--) {
        this._copyValue(arrFrom[i], arrTo[i])
    }
  }

  _reflectValues(arrFrom, arrTo) {
    $(arrFrom.join(',')).on('change keyup', function (evt) {
        this._copyValues(arrFrom, arrTo);
    }.bind(this));
  }

  _copyToggleAction(dispatcher) {
        let arrFrom = new Array('#edit-field-civilite', '#edit-field-nom', '#edit-field-prenom', '#edit-field-nom-extended', '#edit-field-prenom-extended');
    let arrTo = new Array('#edit-field-civilite-concernee', '#edit-field-nom-concernee', '#edit-field-prenom-concernee', '#edit-field-nom-concernee-extended', '#edit-field-prenom-concernee-extended');

    $(dispatcher).on('click', function (evt) {
        if($(dispatcher).is(':checked')) {
            this._copyValues(arrFrom, arrTo);
            this._reflectValues(arrFrom, arrTo);

        } else {
            //reset values to default
            $(arrTo.join(',')).val('');
            $(arrFrom.join(',')).off('change keyup');
        }
    }.bind(this));

  }

}
